const WIDE_CARD_WIDTH = 1024;
const COMPACT_CARD_WIDTH = 744;

export { WIDE_CARD_WIDTH, COMPACT_CARD_WIDTH };
